<!-- Launched from the shared assistance launcher (app-assistance-launcher). -->
@defer (when aiAssistantFacade.isOpen()) {
  <app-ai-assistant-dialog></app-ai-assistant-dialog>
}